import React from 'react';
import * as S from './RelatedAds.styles';
import { MAX_RELATED_ADS } from '@/views/Ads/Ad.view.constants';
import { AdCardNew } from '@/components/AdCardNew';

export function RelatedAdsSkeletonLoader() {
  return (
    <S.Container>
      <S.TitleContainer>
        <S.TitleSkeletonLoader />
        <S.ShowAllLinkSkeletonLoader />
      </S.TitleContainer>
      <S.AdCardsBox>
        {Array.from({ length: MAX_RELATED_ADS }, (_, index) => (
          <AdCardNew key={index} />
        ))}
      </S.AdCardsBox>
    </S.Container>
  );
}
